export default {
  Auth: {
    identityPoolId: 'ca-central-1:2df37420-975d-4ac8-ad59-ed7eddbd4a53',
    region: 'ca-central-1',
    userPoolId: 'ca-central-1_b04H1or9O',
    userPoolWebClientId: '5oq53v4h8fsni9e4eauoh1g737',
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  API: {
    aws_appsync_graphqlEndpoint: 'https://4n2eej6rbreydcd7np6rfk3a3y.appsync-api.ca-central-1.amazonaws.com/graphql',
    aws_appsync_region: 'ca-central-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  },
  Storage: {
    AWSS3: {
      bucket: 'lightning-prod-assets-storage',
      region: 'ca-central-1',
    },
  },
  oauth: {
    domain: 'auth.gosourcery.com',
  },
};
